/**
 * @generated SignedSource<<b0c096d853d256a9ad2c5f3056adc106>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbReturnPolicy_item" | "PdpRespSidebarBlurbShipping_item" | "useRenderBlurbs_item" | "useShowReturns_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRenderBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbReturnPolicy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowReturns_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f87b7577d5d6050978b9365ed1342e20";

export default node;
